import { z } from 'zod';
import { MetaSchema } from './meta';
import { PhasesCO2Schema } from './phases-co2';

export const ComponentCO2CreateSchema = z.object({
	description: z.string(),
	epd: z.string().min(1).max(55),
	name: z.string().min(1).max(55),
	phases: PhasesCO2Schema,
});

export const ComponentCO2LinkBatchCreateSchema = z.object({
	...ComponentCO2CreateSchema.shape,
	links: z.array(z.string().min(1).max(55)),
});

export const ComponentCO2UpdateSchema = z.object({
	...ComponentCO2CreateSchema.shape,
});

export const ComponentCO2Schema = z.object({
	...ComponentCO2UpdateSchema.shape,
	meta: MetaSchema,
	self: z.string().startsWith('/mdm/apps/one/stores/'),
});

export const ComponentCO2ResponseSchema = z.object({
	items: z.array(ComponentCO2Schema),
	self: z.string().startsWith('/mdm/apps/one/stores/'),
});

export type IComponentCO2CreateSchema = z.infer<typeof ComponentCO2CreateSchema>;
export type IComponentCO2LinkBatchCreateSchema = z.infer<typeof ComponentCO2LinkBatchCreateSchema>;
export type IComponentCO2ResponseSchema = z.infer<typeof ComponentCO2ResponseSchema>;
export type IComponentCO2Schema = z.infer<typeof ComponentCO2Schema>;
export type IComponentCO2UpdateSchema = z.infer<typeof ComponentCO2UpdateSchema>;
